var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5c5c5c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1014.34,0H235C105.55,0,0,102.75,0,229.18V850.82C0,977.06,105.35,1080,235,1080h779.36c129.44,0,235-102.75,235-229.18V229.18C1249.32,102.75,1144,0,1014.34,0ZM1169,850.82c0,83.08-69.32,150.88-154.7,150.88H235c-85.18,0-154.69-67.61-154.69-150.88V229.18C80.29,146.1,149.61,78.3,235,78.3h779.36c85.18,0,154.7,67.61,154.7,150.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1885,174.37a74.49,74.49,0,0,0-68.73-6.88l-370.3,148.2c-29.17,11.65-48.17,39.92-48.17,72V697.85c0,32.08,18.8,60.16,48.17,72l370.3,148.2a74.07,74.07,0,0,0,27.8,5.35,75.91,75.91,0,0,0,41.12-12.23c21.94-14.32,34.86-38.58,34.86-65.12V239.49A78.28,78.28,0,0,0,1885,174.37Zm-45.43,668.05L1477.84,697.85V387.31l361.68-144.57V842.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.6624dcd09023d4d75c6c3d00b6917da8.svg";
export { ForwardRef as ReactComponent };